import { $authHost } from 'app/configs/axiosConfig';
import { fullPhoneNumber } from './utils';

export const tryLinkExist = async () => {
  const res = await $authHost.post<{ data: { linked: boolean } }>('/auth/try-link-exist');
  return res.data.data;
};

export const checkEmailOrPhoneUsed = async (email: string, phone?: string) => {
  const res = await $authHost.get<{ data: { emailUsed: boolean; phoneUsed: boolean } }>(
    '/auth/email-or-phone-used',
    { params: { email, phone: fullPhoneNumber(phone) } },
  );
  return res.data.data;
};
